import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    addButton: {
        textTransform: 'none' as 'none',
        fontSize: '.8rem',
        padding: '.25rem .75rem',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#ffffff',
        border: `1px solid ${theme?.app?.clientTheme.colors.buttons.primaryColorLight || '#009BDF'}`,
        borderRadius: '20px',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f3f3f3' }
    },
    buttonText: { paddingLeft: '0.5rem' },
    buttonIcon: {
        height: '16px',
        width: '16px',
        padding: '.25rem',
        border: `1px solid ${theme?.app?.clientTheme.colors.buttons.primaryColorLight || '#009BDF'}`,
        borderRadius: '100%'
    }
}));